import { Heading } from '@chakra-ui/react';
import React from 'react';

import styles from './page-title.module.scss';

export function PageTitle({ children }: { children: string | string[] }) {
  return (
    <Heading as="h1" className={styles.pageTitle} fontFamily="KiaSignature">
      {children}
    </Heading>
  );
}
